// @flow
import React from 'react';
import styled, { css } from 'styled-components';
import Button from './BaseButton';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';
import { Icon } from 'trustar-2.0/components';

const StyledIconButton = styled(Button)`
  padding-right: ${({ padButton }) => (padButton ? '1.75rem' : '1.25rem')};

  i {
    margin-right: ${({ padButton }) => (padButton ? '0.5rem' : '0')};
  }

  ${({ iconToTheRight, padButton }) => css`
    padding-left: ${padButton ? '1.75rem' : '1.25rem'};

    i {
      margin-left: ${padButton ? '0.5rem' : '0'};
    }
  `}
`;

const StyledIconButtonPure = styled(Button)`
  && {
    padding: 0.75rem;
    
    ${({glowHover}) => glowHover && css`
      &:hover {
            .icon {
              font-weight: 800;
              text-shadow: 0px 0px 2px;
            }
          }
        `}
  }
`;

type IconButtonPropType = {
  icon: string,
  children?: any,
  theme?: ThemeType,
  iconToTheRight?: boolean,
  iconSize?: string,
  thin?: boolean,
  className?: string
};

const IconButton = ({
  icon,
  thin,
  children,
  iconToTheRight,
  ...props
}: IconButtonPropType) => {
  return (
    <StyledIconButton padButton={children} {...props}>
      {!iconToTheRight && <Icon icon={icon} fontWeight={thin ? 400 : 800} />}
      {children}
      {iconToTheRight && <Icon icon={icon} fontWeight={thin ? 400 : 800} />}
    </StyledIconButton>
  );
};

type IconButtonPurePropType = {
  ...IconButtonPropType,
  small?: boolean,
  large?: boolean,
  iconSize?: string,
};

const IconButtonPure = ({
  icon,
  large,
  small,
  iconSize,
  ...props
}: IconButtonPurePropType) => {
  let iconFontSize = large ? '1.75rem' : small ? '1rem' : '1.5rem';
  if (iconSize) iconFontSize = iconSize;

  return (
    <StyledIconButtonPure {...props}>
      <Icon
        icon={icon}
        fontSize={iconFontSize}
        fontWeight={props.thin ? 400 : 800}
      />
    </StyledIconButtonPure>
  );
};

export { IconButton, IconButtonPure };


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Button/IconButton.js